import { useState } from 'react'
import './css/App.css'
import Sidebar from './components/Sidebar'
import Document from './components/Document'
import defaultPhoto from './assets/defaultPhoto.jpg'

const mkList = () => [{ id: 0, value: '' }]

function App() {
   const [mode, setMode] = useState('fields')

   const [fields, setFields] = useState({
      photo: defaultPhoto,
      fullname: null,
      jobtitle: null,
      description: null,
      contact: null,
      email: null,
      experience: mkList(),
      skills: mkList(),
      reference: mkList(),
      projects: mkList(),
      education: {
         elementary: {
            school: '',
            yearStart: '',
            yearEnd: '',
            achievements: mkList(),
         },
         highschool: {
            school: '',
            yearStart: '',
            yearEnd: '',
            achievements: mkList(),
         },
         seniorhigh: {
            school: '',
            yearStart: '',
            yearEnd: '',
            achievements: mkList(),
         },
         college: {
            school: '',
            yearStart: '',
            yearEnd: '',
            achievements: mkList(),
         },
      },
   })

   const [design, setDesign] = useState({
      layout: 0,
      fontPair: 0,
      accentColor: '#d4a843',
      headerColor: '#1e1e2e',
      spacing: 1,
      fontSize: 13,
      fontSizeHeader: 13,
      showPhoto: true,
   })

   return (
      <>
         <Sidebar
            field={fields}
            fieldHandler={setFields}
            design={design}
            designHandler={setDesign}
            mode={mode}
         />
         <Document field={fields} design={design} modeHandler={setMode} />
      </>
   )
}

export default App
